import * as React from 'react';
import * as classnames from 'classnames';
import icons from './icons';

/******************************************************************************************************* */
// Icon
/******************************************************************************************************* */

export type TIconType = 'accordion-close' | 'accordion-open' | 'divider-icon' | 'form-checkbox-indeterminate' | 'form-checkbox' | 'form-radio' | 'form-select' | 'list-bullet' | 'nav-parent-close' | 'nav-parent-open' | 'close-icon' | 'close-large' | 'navbar-toggle-icon' | 'overlay-icon' | 'pagination-next' | 'pagination-previous' | 'search-icon' | 'search-large' | 'search-navbar' | 'slidenav-next-large' | 'slidenav-next' | 'slidenav-previous-large' | 'slidenav-previous' | 'spinner' | 'totop' | 'album' | 'arrow-down' | 'arrow-left' | 'arrow-right' | 'arrow-up' | 'ban' | 'behance' | 'bell' | 'bold' | 'bolt' | 'bookmark' | 'calendar' | 'camera' | 'cart' | 'check' | 'chevron-down' | 'chevron-left' | 'chevron-right' | 'chevron-up' | 'clock' | 'close' | 'cloud-download' | 'cloud-upload' | 'code' | 'cog' | 'comment' | 'commenting' | 'comments' | 'copy' | 'credit-card' | 'database' | 'desktop' | 'download' | 'dribbble' | 'expand' | 'facebook' | 'file-edit' | 'file' | 'flickr' | 'folder' | 'forward' | 'foursquare' | 'future' | 'git-branch' | 'git-fork' | 'github-alt' | 'github' | 'google-plus' | 'google' | 'grid' | 'happy' | 'hashtag' | 'heart' | 'history' | 'home' | 'image' | 'info' | 'instagram' | 'italic' | 'joomla' | 'laptop' | 'lifesaver' | 'link' | 'linkedin' | 'list' | 'location' | 'lock' | 'mail' | 'menu' | 'minus-circle' | 'minus' | 'more-vertical' | 'more' | 'move' | 'nut' | 'pagekit' | 'paint-bucket' | 'pencil' | 'phone-landscape' | 'phone' | 'pinterest' | 'play-circle' | 'play' | 'plus-circle' | 'plus' | 'pull' | 'push' | 'question' | 'quote-right' | 'receiver' | 'refresh' | 'reply' | 'rss' | 'search' | 'server' | 'settings' | 'shrink' | 'sign-in' | 'sign-out' | 'social' | 'soundcloud' | 'star' | 'strikethrough' | 'table' | 'tablet-landscape' | 'tablet' | 'tag' | 'thumbnails' | 'trash' | 'triangle-down' | 'triangle-left' | 'triangle-right' | 'triangle-up' | 'tripadvisor' | 'tumblr' | 'tv' | 'twitter' | 'uikit' | 'unlock' | 'upload' | 'user' | 'users' | 'video-camera' | 'vimeo' | 'warning' | 'whatsapp' | 'wordpress' | 'world' | 'xing' | 'yelp' | 'youtube';
export type TIconTagName = 'span' | 'button' | 'a';

export interface IIconBaseProps {
    readonly iconTagName?: TIconTagName;
    readonly iconType: TIconType;
    readonly iconRatio?: number;
}

// --

export interface IIconProps extends React.HTMLAttributes<HTMLElement>, IIconBaseProps {

}

/**
 * Icon
 */
export class Icon extends React.Component<IIconProps, {}> {

    static uiPrefix: string = 'uk-icon';

    static defaultProps: Partial<IIconProps> = {
        iconRatio: 1,
        iconTagName: 'span'
    }

    static createElement(props: IIconProps, ...children: React.ReactNode[]) {
        return React.createElement(Icon, props, ...children);
    }

    static renderSvg(iconRatio: number, iconType: TIconType) {
        return React.createElement('svg', {
            viewBox: icons[iconType].viewBox,
            width: iconRatio * parseInt(icons[iconType].width),
            height: iconRatio * parseInt(icons[iconType].height),
            dangerouslySetInnerHTML: { __html: icons[iconType].html },
        })
    }

    render() {

        const { className, iconTagName, iconRatio, iconType, children, ...rest } = this.props;

        return React.createElement(iconTagName, {
            className: classnames(
                Icon.uiPrefix,
                className,
            ),
            ...rest
        },
            Icon.renderSvg(iconRatio, iconType),
            children
        );
    }
}